// Presentation only: retain the original punch and stored attendance record.
export function attendanceDisplay(record, user) {
  if (!record) return record;
  const actual = record.actual_first_in || record.first_in || record.check_in_time || record.check_in;
  const base = { ...record, check_in: actual, display_first_in: actual };
  if (!actual || ['LEAVE', 'ABSENT', 'HALF_DAY', 'EXCEPTION'].includes(String(record.status).toUpperCase())) return base;
  let hour, minute;
  const raw = String(actual);
  if (/Z$|[+-]\d{2}:\d{2}$/.test(raw)) {
    const date = new Date(actual);
    if (Number.isNaN(date.getTime())) return base;
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Karachi', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(date);
    hour = Number(parts.find(p => p.type === 'hour').value);
    minute = Number(parts.find(p => p.type === 'minute').value);
  } else {
    const match = raw.match(/(?:^|[T ])(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?/i);
    if (!match) return base;
    hour = Number(match[1]); minute = Number(match[2]);
    if (match[3]) hour = hour % 12 + (match[3].toUpperCase() === 'PM' ? 12 : 0);
  }
  const roles = [...(Array.isArray(user?.roles) ? user.roles : []), user?.role].filter(Boolean).map(r => String(r).trim().toLowerCase());
  const cutoff = roles.some(r => ['admin', 'hr'].includes(r)) ? 645 : 630;
  const late = Math.max(0, hour * 60 + minute - cutoff);
  return { ...base, status: late ? 'LATE' : 'PRESENT', display_status: late ? 'LATE' : 'PRESENT', late_minutes: late, display_late_minutes: late };
}

export function attendanceSummaryDisplay(payload, user) {
  if (!payload?.lists) return payload;
  const lists = Object.fromEntries(Object.entries(payload.lists).map(([key, rows]) => [key, rows.map(row => ({ ...row, attendance: attendanceDisplay(row.attendance, user) }))]));
  lists.late = (lists.present || []).filter(row => !row.isOffDay && row.attendance?.status === 'LATE');
  return { ...payload, lists, summary: { ...payload.summary, totalLate: lists.late.length } };
}
